import { Injectable } from "@angular/core";
import { TablesHttpService } from "./tables-http.service";
import { catchError, EMPTY, Observable, of } from "rxjs";
import { TableWordNoun, TableWordVerb } from "@model";


@Injectable({ providedIn: "root" })
export class TablesService {
  constructor(private _tablesHttpService: TablesHttpService) {
  }

  getTableWordNoun(lemma: string): Observable<TableWordNoun | null> {
    return this._tablesHttpService.loadTableWordNoun(lemma).pipe(catchError((error) => {
      console.log(`!!! error while loading noun: `, lemma, error)
      return of(null);
    }))
  }

  getTableWordVerb(lemma: string): Observable<TableWordVerb | null> {
    return this._tablesHttpService.loadTableWordVerb(lemma).pipe(catchError((error) => {
      console.log(`!!! error while loading verb: `, lemma, error)
      return of(null);
    }))
  }
}
